<template>
    <v-dialog :value="value" @input="$emit('input')" scrollable max-width="700px" persistent transition="dialog-transition">
        <v-container>
            <v-card>
                <v-card-title primary-title>
                    <h1>INFORMATIVA SUL TRATTAMENTO DEI DATI PERSONALI "PRIVACY"</h1>
                </v-card-title>
                <v-divider class="mx-2"></v-divider>
                <v-card-text>
                    <h2>Prenotazioni e accettazione</h2>
                    
                    <p>
                        Desideriamo informarLa che i Suoi dati personali, raccolti tramite iscrizione o prenotazione, saranno utilizzati da parte di B&B Oblò, nel pieno rispetto dei principi fondamentali, dettati dal decreto legislativo n. 196 del 30 giugno 2003 Codice in materia di protezione dei dati personali e dal Regolamento Europeo 679/2016 - GDPR.
                    </p>
                    
                    <p>Operazioni di trattamento dei dati personali e relativa finalità.</p>

                    <p>
                        Di seguito, Le riepiloghiamo ai sensi dell’art. 13, paragrafo 1 del GDPR 679/2016, tutte le operazioni da noi svolte che implicano raccolta, conservazione od elaborazione dei Suoi dati personali, e gli scopi che perseguiamo con ciascuna di esse:
                    </p>

                    <p>
                        <ol>
                            <li>Raccolta e conservazione dei Suoi dati personali al fine della fornitura del servizio di prenotazione/acquisto. Trattandosi di trattamenti necessari per la definizione dell’accordo contrattuale e per la sua successiva attuazione, il conferimento è obbligatorio.</li>
                            <li>Utilizzo dei suoi dati per finalità di marketing e promozionali, comunicazioni inerenti la prenotazione e non. Invio di comunicazioni inerenti offerte, promozioni e/o per via esemplificativa tariffe sconto riservate. Per tale finalità, previa acquisizione del suo consenso opzionale, i suoi dati saranno conservati e non saranno comunicati a terzi. Potrà revocare il consenso in qualsiasi momento;</li>
                            <li>Al fine dell’adempimento previsto dal “Testo unico delle leggi di pubblica sicurezza” (articolo 109 R.D. 18.6.1931 n. 773) che ci impone di comunicare alla Questura, per fini di pubblica sicurezza, le generalità dei clienti alloggiati secondo le modalità stabilite dal Ministero dell’Interno (Decreto 7 gennaio 2013). Il conferimento dei dati è obbligatorio, ed in caso di rifiuto a fornirli non potremo ospitarla nella nostra struttura. I dati acquisiti per tale finalità non vengono da noi conservati;</li>
                            <li>Al fine dell’adempimento previsto per gli obblighi amministrativi, contabili e fiscali. Per tali finalità il trattamento è effettuato senza necessità di acquisire il suo consenso. I dati sono trattati da noi e da nostri incaricati (ad es. consulente amministrativo, fiscale, tributario), e vengono comunicati all’ esterno solo in adempimento ad obblighi di legge. In caso di rifiuto a conferire i dati necessari per gli adempimenti sopra indicati, non potremo fornirle i servizi richiesti. I dati acquisiti per tali finalità vengono da noi conservati per il tempo previsto dalle rispettive normative (10 anni, e anche oltre in caso di accertamenti fiscali);</li>
                            <li>Per accelerare le procedure di registrazione in caso di suoi successivi soggiorni presso la nostra struttura. Per tale finalità, previa acquisizione del suo consenso al momento dell’arrivo in struttura, revocabile in qualsiasi momento, i suoi dati saranno conservati e saranno utilizzati quando sarà nuovamente nostro ospite per le finalità di cui ai punti precedenti;</li>
                        </ol>
                    </p>

                    <p>
                        Libertà di rilasciare il consenso e conseguenze di un rifiuto.
                        Il conferimento del consenso al trattamento dei dati personali è necessario per permetterci di poter dare seguito alla Sua richiesta. In caso di rifiuto alla prestazione del consenso non ci sarà possibile erogarLe i servizi richiesti.

                        In caso di rifiuto del consenso non vi sarà alcuna conseguenza.
                    </p>

                    <h4>In caso di conferma, i dati saranno comunicati a:</h4>

                    <p>
                        <p>
                            B&B Oblò di Antonella Maria Ravidà
                        </p>
                        <p>
                            Piazza dei Martiri 3
                        </p>
                        <p>
                            95131  Catania  (CT )
                        </p>
                        <p>
                            Email: info@oblobb.it 
                        </p>
                    </p>

                    <p>
                        e a eventuali incaricati nominati dal Responsabile del Trattamento (art.29 del D.Lgs. 196/03 e Art. 28 del GDPR 679/2016).

                        Diritti di cui all'Art. 7 del D.Lgs. 196/03 e all’Art. 7, par. 3, del GDPR 679/2016.Lei ha diritto di aggiornare, modificare, cancellare i suoi dati Lei ha diritto di aggiornare, modificare, cancellare i suoi dati (articoli da 15 a 22 del Regolamento UE n. 679 del 2016). Può inoltre proporre reclamo all’autorità di controllo, secondo le procedure previste dalla normativa vigente.
                    </p>

                    <p>
                        <h4>Titolare e responsabile del trattamento è:</h4>

                        <p>
                            <p>
                                B&B Oblò di Antonella Maria Ravidà
                            </p>
                            <p>
                                Piazza dei Martiri 3
                            </p>
                            <p>
                                95131  Catania  (CT )
                            </p>
                            <p>
                                Email: info@oblobb.it 
                            </p>
                        </p>
                    </p>

                    <p>
                        <h4>Le eventuali istanze ai sensi dell'art. 7 del D. Lgs. 196/03 dovranno essere indirizzate a:</h4>

                        <p>
                            <p>
                                B&B Oblò di Antonella Maria Ravidà
                            </p>
                            <p>
                                Piazza dei Martiri 3
                            </p>
                            <p>
                                95131  Catania  (CT )
                            </p>
                            <p>
                                Email: info@oblobb.it 
                            </p>
                        </p>
                    </p>

                    <p>
                        In mancanza di uno o più dei precedenti dati è necessario fare riferimento all'indirizzo della struttura ricettiva a cui ha prenotato.
                        L'indirizzo è quasi sempre disponibile nel voucher di conferma della prenotazione.
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="$emit('close-privacy')">Ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-container>
    </v-dialog>
</template>

<script>
export default {
    props: { value: { required: true } },

    data: () => {
        return {

        }
    }
}
</script>